import { b } from '@angular/core/src/render3';

declare const webpackGlobalVars: any;

export class AppConstants {
	constructor() {}

	static isBrowser: boolean = typeof (<any>window).cordova === 'undefined';

	static apiServer = webpackGlobalVars ? webpackGlobalVars.server : '';

	static APP_HOST_SERVER = AppConstants.isBrowser ? '' : AppConstants.apiServer;

	static IS_PROD_BUILD = webpackGlobalVars
		? webpackGlobalVars.env === 'production'
		: false;

	static IS_TEST_BUILD = webpackGlobalVars
		? webpackGlobalVars.env === 'testing'
		: false;

	static HOST = webpackGlobalVars ? webpackGlobalVars.server : '';
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=oom9nsliule!./shared/models/appConstants.ts